import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setDraggingItem } from '../../../containers/planning/planningSlice';
import { addFavoriteShiftSample, deleteFavoriteShiftSample } from '../shifts/sampleShiftsSlice';
import { addFavoriteLeaveSample, deleteFavoriteLeaveSample } from '../leave/leaveSampleSlice';
import { ShiftCell } from '../../scheduler/cells/shiftCell.js';
import { Localize } from '../../../app/lang/langs';
import styles from './Rows.module.css';
import { getUserPreferences } from '../../../app/utils/helpers';


export function SamplesRow(props) {

    const dispatch = useDispatch()
    const selectedSamplesView = useSelector((state) => state.planning.selectedSamplesView)
    const sampleShifts = useSelector((state) => state.sampleShifts.list)
    const userId = useSelector((state) => state.login.userId)
    const sampleLeaves = useSelector((state) => state.sampleLeaves.list)
    const draggingItem = useSelector((state) => state.planning.draggingItem)

    const handleDragStart = (value, event) => {
        if (draggingItem !== value)
            dispatch(setDraggingItem(value))
    }

    const handleDragStop = (value, event) => {
        dispatch(setDraggingItem(null))
    }

    // Both sample shifts and sample leaves carry the is_favorite flag.
    const isFavoritable = (shift) => typeof shift.is_favorite === 'boolean'

    const handleToggleFavorite = (shift, event) => {
        event.stopPropagation()
        // Shifts and leaves live in different tables (and slices), so route the
        // toggle by sampleType tagged in each slice.
        if (shift.sampleType === 'leave') {
            if (shift.is_favorite) {
                dispatch(deleteFavoriteLeaveSample({ id_sample_leave: shift.id }))
            } else {
                dispatch(addFavoriteLeaveSample({ id_sample_leave: shift.id }))
            }
        } else {
            if (shift.is_favorite) {
                dispatch(deleteFavoriteShiftSample({ id_sample_shift: shift.id }))
            } else {
                dispatch(addFavoriteShiftSample({ id_sample_shift: shift.id }))
            }
        }
    }

    function getSamples() {
        if (selectedSamplesView === "SHIFTS") {
            let shiftsArray = []
            if (sampleShifts && sampleShifts.length) {
                shiftsArray = shiftsArray.concat(sampleShifts)
            }
            if (sampleLeaves && sampleLeaves.length) {
                shiftsArray = shiftsArray.concat(sampleLeaves.filter(s => s.visibility))
            }
            let shiftsUserOrder = getUserPreferences(userId, "SHIFTS_SAMPLES_ORDER")
            if (shiftsUserOrder) {
                shiftsArray = shiftsArray.sort((a, b) => {
                    return shiftsUserOrder.indexOf(`${a["id"]}`) - shiftsUserOrder.indexOf(`${b["id"]}`)
                })
            }
            // Favorites float to the front (stable sort keeps the existing order within each group)
            shiftsArray = shiftsArray.sort((a, b) => (b.is_favorite === true ? 1 : 0) - (a.is_favorite === true ? 1 : 0))
            return shiftsArray.map(shift => {
                if (shift.id)
                    return <div key={"ShiftCell_" + (shift.sampleType || 'shift') + "_" + shift.id}
                        draggable={true}
                        className={styles.draggableShift}
                        onDragStart={(handleDragStart.bind(this, shift))}
                        onDragEnd={handleDragStop.bind(this, shift)}>
                        <ShiftCell data={shift} isInteractive={false} />
                        {isFavoritable(shift) && (
                            <button
                                type="button"
                                className={`${styles.favoriteStarBtn} ${shift.is_favorite ? styles.favoriteStarBtnActive : ''}`}
                                onClick={(e) => handleToggleFavorite(shift, e)}
                                onMouseDown={(e) => e.stopPropagation()}
                                title={Localize(shift.is_favorite ? "REMOVE_FROM_FAVORITES" : "ADD_TO_FAVORITES")}
                            >
                                {shift.is_favorite ? '★' : '☆'}
                            </button>
                        )}
                    </div>
            })
        }
    }

    return <div className={styles.samplesContainer}>
        {getSamples()}
    </div>
}
